/**
 * Standardized payment error codes and types
 * Used across all payment handlers and checkout service to ensure consistency
 */

// Standardized error codes for specific payment scenarios
export const PAYMENT_ERROR_CODES = {
  // UI-level checkout errors
  GENERAL_ERROR: "general_error",
  PRODUCT_SELECTION_ERROR: "product_selection_error",
  PAYMENT_METHOD_ERROR: "payment_method_error",
  PAYMENT_METHOD_NOT_SELECTED: "payment_method_not_selected",
  SESSION_EXPIRED_ERROR: "session_expired_error",
  REGION_RESTRICTION_ERROR: "region_restriction_error",
  PAYMENT_GATEWAY_UNAVAILABLE: "payment_gateway_unavailable",
  PAYMENT_GATEWAY_NOT_ALLOWED_FOR_COUNTRY:
    "payment_gateway_not_allowed_for_country",
  CHECKOUT_UI_MISSING_ELEMENTS: "checkout_ui_missing_elements",
  VARIATION_ID_INVALID: "variation_id_invalid",
  // Authentication errors
  AUTHENTICATION_REQUIRED: "authentication_required",
  PAYMENT_INTENT_AUTHENTICATION_FAILURE:
    "payment_intent_authentication_failure",
  AUTHENTICATION_CANCELLED: "authentication_cancelled",
  PAYMENT_GATEWAY_BLOCKED: "payment_gateway_blocked",
  PAYMENT_GATEWAY_NETWORK_ERROR: "payment_gateway_network_error",

  // Payment errors
  CARD_DECLINED: "card_declined",
  INSUFFICIENT_FUNDS: "insufficient_funds",
  PAYMENT_FAILED: "payment_failed",
  BILLING_DATA_COLLECTION_FAILED: "billing_data_collection_failed",
  VARIANT_FETCH_FAILED: "variant_fetch_failed",

  // Order processing errors
  ORDER_CREATION_FAILED: "order_creation_failed",
  REDIRECT_PARSE_FAILED: "redirect_parse_failed",

  // General processing errors
  PAYMENT_PROCESSING_ERROR: "payment_processing_error",
  NETWORK_ERROR: "network_error",
  VALIDATION_ERROR: "validation_error",
  CART_UPDATE_FAILED: "cart_update_failed",
  PAYMENT_GATEWAY_UI_INITIALIZATION_FAILED:
    "payment_gateway_ui_initialization_failed",
  CHECKOUT_FORM_VALIDATION_ERROR: "checkout_form_validation_error",
  ACCOUNT_SELECTION_VALIDATION_ERROR: "account_selection_validation_error",

  // Checkout errors
  CHECKOUT_BANNED_USER: "checkout_banned_user",

  COUPON_LIMIT_REACHED: "woocommerce_rest_cart_coupon_errors",
  KORA_CANCELLED_BY_USER: "korapay_cancelled_by_user",
  REST_INVALID_PARAM: "rest_invalid_params",
} as const;

export const COUPON_ERROR_CODES = {
  COUPON_NOT_FOUND: "coupon_not_found",
  COUPON_INACTIVE: "coupon_inactive",
  COUPON_EXPIRED: "coupon_expired",
  COUPON_LIMIT_REACHED: "woocommerce_rest_cart_coupon_errors",
  COUPON_CODE_REQUIRED: "coupon_code_required",
  COUPON_MINIMUM_AMOUNT: "coupon_minimum_amount",
  COUPON_MAXIMUM_AMOUNT: "coupon_maximum_amount",
  COUPON_INDIVIDUAL_USE: "coupon_individual_use",
  COUPON_PRODUCT_RESTRICTION: "coupon_product_restriction",
  COUPON_NETWORK_ERROR: "coupon_network_error",
  COUPON_ALREADY_USED: "coupon_already_used",
  COUPON_APPLY_FAILED: "coupon_apply_failed",
} as const;

// Type definitions for TypeScript
export type PAYMENT_ERROR_TYPES =
  (typeof PAYMENT_ERROR_CODES)[keyof typeof PAYMENT_ERROR_CODES];

export type COUPON_ERROR_TYPES =
  (typeof COUPON_ERROR_CODES)[keyof typeof COUPON_ERROR_CODES];
